import '.ab{border-radius:1.25rem;}.ssr-plugin'
import '.ad{overflow:hidden;}.ssr-plugin'
import '.gk{border:var(--gray-border);}.ssr-plugin'
import '.gl{min-height:420px;}.ssr-plugin'
import '.bh{height:100%;}.ssr-plugin'
import '.h{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  return (
    <styled.div className={`${className} ab ad gk gl bh h i`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
